module.exports = __webpack_public_path__ + "media/images/logos/accenture_logo-b3fa7dba8c209cf233d4f8cf0596e1f0.png";